<template>
  <v-container
    fluid
    fill-height
    class="black"
    style="background: url('/img/bg.jpg') bottom right fixed no-repeat; background-size: cover"
  >
    <v-row dense>
      <v-col
        cols="12"
        class="text-center white--text"
      >
        <h1 v-text="$t('Promotion.Home.Title')" />
        <div class="my-4">
          <h3 v-text="$t('Promotion.Home.SubTitle')" />
          <h5 v-text="$t('Promotion.Home.Slogan')" />
        </div>
      </v-col>
    </v-row>

    <v-row
      align="center"
      justify="center"
      no-gutters
    >
      <v-col
        cols="12"
        md="10"
        lg="8"
        xl="6"
      >
        <template v-if="$DataStore.MaintenanceMode">
          <v-alert
            border="bottom"
            type="warning"
            class="pa-6"
            prominent
            text
            style="background: #1E1E1E !important;"
          >
            {{ $t('Common.Error.MaintenanceMode') }}
          </v-alert>
        </template>

        <template v-else>
          <v-card
            min-height="450"
            min-width="280"
            max-width="1200"
          >
            <div
              v-if="!registerSuccess"
              class="pa-4 text-center justify-center"
            >
              <v-card-title
                class="justify-center text-no-wrap"
                :class="[{'subtitle-1 font-weight-bold': $vuetify.breakpoint.xs}]"
              >
                Καταχωρήστε τα στοιχεία σας
              </v-card-title>
              <v-card-subtitle>
                Αποκτήστε συμμετοχή στα προγράμματα ανταμοιβής Pirelli με μοναδικές προσφορές!
              </v-card-subtitle>
            </div>
            <div
              v-else
              class="pa-4 text-center justify-center"
            >
              <v-card-title
                class="justify-center text-no-wrap"
                :class="[{'subtitle-1 font-weight-bold': $vuetify.breakpoint.xs}]"
              >
                Η εγγραφή σας ολοκληρώθηκε με επιτυχία!
              </v-card-title>
            </div>

            <v-divider />

            <v-card-text
              ref="formContainer"
              class="pa-6"
            >
              <v-form
                ref="form"
                v-model="formValid"
              >
                <template v-if="!registerSuccess && editItem && editItem.GDPR">
                  <v-row>
                    <v-col
                      cols="12"
                      class="pt-0"
                    >
                      <v-switch
                        v-model="editItem.IsCompany"
                        :rules="validator.vuetifyFormFieldRules('IsCompany')"
                        :error-messages="serverErrorMessages['IsCompany']"
                        :label="$t(`Promotion.Form.Fields.IsCompany.Label`)"
                        color="success"
                        inset
                        hide-details
                        class="ma-0 mr-4 pt-4 d-inline-flex"
                        @change="onIsCompanyChange"
                      />
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col
                      v-show="editItem.IsCompany"
                      cols="12"
                      :sm="editItem.IsCompany ? 4 : 6"
                      class="pt-0"
                    >
                      <v-text-field
                        v-model="editItem.CompanyName"
                        :rules="validator.vuetifyFormFieldRules('CompanyName')"
                        :error-messages="serverErrorMessages['CompanyName']"
                        :label="$t(`Promotion.Form.Fields.CompanyName.Label`)"
                        :hint="$t(`Promotion.Form.Fields.CompanyName.Hint`)"
                        :disabled="!editItem.IsCompany"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      :sm="editItem.IsCompany ? 4 : 6"
                      class="pt-0"
                    >
                      <v-text-field
                        v-model="editItem.Firstname"
                        :rules="validator.vuetifyFormFieldRules('Firstname')"
                        :error-messages="serverErrorMessages['Firstname']"
                        :label="$t(`Promotion.Form.Fields.Firstname.Label`)"
                        :hint="$t(`Promotion.Form.Fields.Firstname.Hint`)"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      :sm="editItem.IsCompany ? 4 : 6"
                      class="pt-0"
                    >
                      <v-text-field
                        v-model="editItem.Lastname"
                        :rules="validator.vuetifyFormFieldRules('Lastname')"
                        :error-messages="serverErrorMessages['Lastname']"
                        :label="$t(`Promotion.Form.Fields.Lastname.Label`)"
                        :hint="$t(`Promotion.Form.Fields.Lastname.Hint`)"
                      />
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col
                      cols="12"
                      sm="4"
                      class="pt-0"
                    >
                      <v-text-field
                        v-model="editItem.Email"
                        :rules="validator.vuetifyFormFieldRules('Email')"
                        :error-messages="serverErrorMessages['Email']"
                        :label="$t(`Promotion.Form.Fields.Email.Label`)"
                        :hint="$t(`Promotion.Form.Fields.Email.Hint`)"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      sm="4"
                      class="pt-0"
                    >
                      <v-text-field
                        v-model="editItem.Phone"
                        v-mask="['69########']"
                        :rules="validator.vuetifyFormFieldRules('Phone')"
                        :error-messages="serverErrorMessages['Phone']"
                        :label="$t(`Promotion.Form.Fields.Phone.Label`)"
                        :hint="$t(`Promotion.Form.Fields.Phone.Hint`)"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      sm="4"
                      class="pt-0"
                    >
                      <v-text-field
                        v-model="editItem.ZipCode"
                        v-mask="['#####']"
                        :rules="validator.vuetifyFormFieldRules('ZipCode')"
                        :error-messages="serverErrorMessages['ZipCode']"
                        :label="$t(`Promotion.Form.Fields.ZipCode.Label`)"
                        :hint="$t(`Promotion.Form.Fields.ZipCode.Hint`)"
                      />
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col
                      cols="12"
                      sm="4"
                      class="pt-0"
                    >
                      <v-autocomplete
                        v-model="editItem.BrandId"
                        :items="carBrands"
                        :rules="validator.vuetifyFormFieldRules('BrandId')"
                        :error-messages="serverErrorMessages['BrandId']"
                        :label="$t(`Promotion.Form.Fields.BrandId.Label`)"
                        :hint="$t(`Promotion.Form.Fields.BrandId.Hint`)"
                        clearable
                        item-text="Name"
                        item-value="Id"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      sm="4"
                      class="pt-0"
                    >
                      <v-autocomplete
                        v-model="editItem.CarId"
                        :items="carModels"
                        :rules="validator.vuetifyFormFieldRules('CarId')"
                        :error-messages="serverErrorMessages['CarId']"
                        :label="$t(`Promotion.Form.Fields.CarId.Label`)"
                        :hint="$t(`Promotion.Form.Fields.CarId.Hint`)"
                        clearable
                        item-text="Name"
                        item-value="Id"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      sm="4"
                      class="pt-0"
                    >
                      <v-text-field
                        v-model="editItem.PlateNumber"
                        :rules="validator.vuetifyFormFieldRules('PlateNumber')"
                        :error-messages="serverErrorMessages['PlateNumber']"
                        :label="$t(`Promotion.Form.Fields.PlateNumber.Label`)"
                        :hint="$t(`Promotion.Form.Fields.PlateNumber.Hint`)"
                      />
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col class="text-justify">
                      {{ $t(`Promotion.Form.NoticeHint`) }}
                      <a
                        href="https://www.pirelli.com/tyres/el-gr/car/privacy-dealer-locator"
                        target="_blank"
                        @click.stop
                      >{{ $t('Promotion.Form.PrivacyText') }}</a>
                    </v-col>

                    <v-col cols="12">
                      <div
                        class="caption"
                        v-html=" $t('Promotion.Form.TermsHint')"
                      />

                      <v-switch
                        v-model="editItem.Privacy"
                        :label="$t(`Promotion.Form.Fields.Privacy.Label`)"
                        :rules="validator.vuetifyFormFieldRules('Privacy')"
                        :error-messages="serverErrorMessages['Privacy']"
                        hide-details="auto"
                        color="success"
                        inset
                      >
                        <template v-slot:label>
                          <div>
                            {{ $t(`Promotion.Form.Fields.Privacy.Label`) }}
                            <a
                              href="https://www.pirelli.com/tyres/el-gr/car/privacy-dealer-locator"
                              target="_blank"
                              @click.stop
                            >{{ $t(`Promotion.Form.PrivacyText`) }}</a>
                          </div>
                        </template>
                      </v-switch>

                      <v-switch
                        v-model="editItem.Terms"
                        :rules="validator.vuetifyFormFieldRules('Terms')"
                        :error-messages="serverErrorMessages['Terms']"
                        hide-details="auto"
                        color="success"
                        inset
                      >
                        <template v-slot:label>
                          <div>
                            {{ $t('Promotion.Form.Fields.Terms.Label') }}
                            <a
                              href="#"
                              @click.stop="onTermsClick"
                              v-text="$t('Promotion.Form.Fields.Terms.Single')"
                            />
                            {{ $t('Promotion.Form.Fields.Terms.Hint') }}
                          </div>
                        </template>
                      </v-switch>
                    </v-col>

                    <v-col cols="12">
                      <div
                        class="caption"
                        v-html="$t('Promotion.Form.GDPRHint')"
                      />

                      <v-switch
                        v-model="editItem.GDPR.Email"
                        :label="$t(`Promotion.Form.Fields.GDPR.Email.Label`)"
                        :rules="validator.vuetifyFormFieldRules('GDPR.Email')"
                        :error-messages="serverErrorMessages['GDPR.Email']"
                        :true-value="1"
                        :false-value="0"
                        hide-details="auto"
                        color="success"
                        inset
                        @change="onGDPRChange"
                      />

                      <v-switch
                        v-model="editItem.GDPR.Phone"
                        :label="$t(`Promotion.Form.Fields.GDPR.Phone.Label`)"
                        :rules="validator.vuetifyFormFieldRules('GDPR.Phone')"
                        :error-messages="serverErrorMessages['GDPR.Phone']"
                        :true-value="1"
                        :false-value="0"
                        hide-details="auto"
                        color="success"
                        inset
                        @change="onGDPRChange"
                      />

                      <v-switch
                        v-model="editItem.GDPR.SMS"
                        :label="$t(`Promotion.Form.Fields.GDPR.SMS.Label`)"
                        :rules="validator.vuetifyFormFieldRules('GDPR.SMS')"
                        :error-messages="serverErrorMessages['GDPR.SMS']"
                        :true-value="1"
                        :false-value="0"
                        hide-details="auto"
                        color="success"
                        inset
                        @change="onGDPRChange"
                      />

                      <v-switch
                        v-model="GDPRAll"
                        :label="$t(`Promotion.Form.Fields.GDPR.All.Label`)"
                        hide-details="auto"
                        color="success"
                        inset
                        @change="(v) => editItem.GDPR.Email = editItem.GDPR.Phone = editItem.GDPR.SMS = v ? 1 : 0"
                      />
                    </v-col>
                  </v-row>
                </template>

                <template v-else-if="registerSuccess">
                  <div class="pa-2 d-flex align-center justify-center">
                    <v-icon
                      color="light-green"
                      size="256"
                    >
                      mdi-check-circle
                    </v-icon>
                  </div>
                </template>
              </v-form>
            </v-card-text>

            <template v-if="!registerSuccess">
              <v-divider />

              <v-card-actions class="pa-4 align-center justify-center">
                <v-btn
                  color="pyellow"
                  class="black--text font-weight-bold"
                  min-width="230"
                  x-large
                  :loading="isSaving"
                  :disabled="isSaving"
                  @click="saveItem"
                >
                  {{ $t('Common.Button.Register') }}
                </v-btn>
              </v-card-actions>
            </template>
          </v-card>
        </template>
      </v-col>
    </v-row>
    <terms-view-dialog :visible.sync="termsDialogVisible" />
  </v-container>
</template>

<script>

import formData        from '../../mixins/formData'
import PromotionModel  from '../../api/models/PromotionModel'
import { API }         from '../../api/Api'
import TermsViewDialog from '../../components/common/TermsViewDialog'

export default {
  name      : 'Promotion',
  components: { TermsViewDialog },
  directives: {},
  mixins    : [PromotionModel, formData],
  props     : [],
  data () {
    return {
      GDPRAll           : false,
      termsDialogVisible: false,
      registerSuccess   : false,
    }
  },
  computed  : {
    maintenanceMode () {
      return this.$DataStore.MaintenanceMode
    },

    carBrands () {
      return this.$DataStore.Data.CarBrands
    },

    carModels () {
      return this.$DataStore.Data.CarModels.filter(c => c.BrandId === this.editItem.BrandId)
    },
  },
  watch     : {},
  beforeCreate () {},
  created () {},
  beforeMount () {},
  mounted () {
    if (!this.maintenanceMode) this.formInit()
  },
  beforeUpdate () {},
  updated () {},
  beforeDestroy () {},
  destroyed () {},
  methods   : {
    saveItem () {
      /*this.formValidate()
      this.validator.validate()
      console.log(this.validator.validationMessages, this.validator)*/

      if (!this.formValidate() || this.isSaving) return
      this.isSaving = true
      API.Promotion.Participate(this.editItem)
        .then(response => {
          this.handleFormSaveResponse(response)
          if (response.data.status === 'success') {
            if (response.data.data === true) {
              this.registerSuccess = true
              this.GDPRAll = false
              setTimeout(() => {
                this.registerSuccess = false
                this.onIsCompanyChange()
              }, 5000)
            }
          } else {
            if (!response.data) {
              this.$DataStore.MaintenanceMode = true
            }
          }
        })
        .catch(error => {
          this.formSaveError(error)
        })
        .finally(() => {
          this.isSaving = false
        })
    },

    onTermsClick (e) {
      e.preventDefault()
      this.termsDialogVisible = true
    },

    onGDPRChange (v) {
      this.GDPRAll = this.editItem.GDPR.Email === 1 && this.editItem.GDPR.Phone === 1 && this.editItem.GDPR.SMS === 1
    },

    onIsCompanyChange () {
      if (this.$refs.form) this.$refs.form.resetValidation()
      if (this.editItem.IsCompany) {
        if (this.validator) {
          if (this.validator.rules.CompanyName) this.validator.rules.CompanyName.required = true
          if (this.validator.rules.Firstname) this.validator.rules.Firstname.required = false
          if (this.validator.rules.Lastname) this.validator.rules.Lastname.required = false
        }
      } else {
        this.editItem.CompanyName = ''
        if (this.validator) {
          if (this.validator.rules.CompanyName) this.validator.rules.CompanyName.required = false
          if (this.validator.rules.Firstname) this.validator.rules.Firstname.required = true
          if (this.validator.rules.Lastname) this.validator.rules.Lastname.required = true
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
